import { render, staticRenderFns } from "./CustomAttribute.vue?vue&type=template&id=8f57a37a&scoped=true&"
import script from "./CustomAttribute.vue?vue&type=script&lang=js&"
export * from "./CustomAttribute.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttribute.vue?vue&type=style&index=0&id=8f57a37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f57a37a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f57a37a')) {
      api.createRecord('8f57a37a', component.options)
    } else {
      api.reload('8f57a37a', component.options)
    }
    module.hot.accept("./CustomAttribute.vue?vue&type=template&id=8f57a37a&scoped=true&", function () {
      api.rerender('8f57a37a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/CustomAttribute.vue"
export default component.exports